export enum USER_PROVIDERS {
  "Email" = "Email",
}

export enum USER_ROLES {
  "Admin" = "Admin",
  "Operator" = "Operator",
  "Member" = "Member",
  "Unapproved" = "Unapproved",
}

export enum USER_TOKEN_TYPE {
  "Auth" = "Auth",
  "PasswordReset" = "PasswordReset",
  "EmailVerified" = "EmailVerified",
  "LoginAttempts" = "LoginAttempts",
  "TwoFactorAuth" = "TwoFactorAuth",
}

export enum USER_TOKEN_REASON {
  "NewAccount" = "NewAccount",
  "PasswordReset" = "PasswordReset",
}

export enum USER_VALIDATION_ERROR {
  "UNAUTHORIZED" = "UNAUTHORIZED",
  "TOO_MANY_ATTEMPTS" = "TOO_MANY_ATTEMPTS",
  "INACTIVE" = "INACTIVE",
}

export enum USER_TWOFACTOR_AUTH {
  "Email" = "Email",
}

export enum USER_AUTH_STATES {
  "unauthenticated" = "unauthenticated",
  "expiredPassword" = "expiredPassword",
  "resetPassword" = "resetPassword",
  "setPassword" = "setPassword",
  "authenticated" = "authenticated",
  "registerEmail" = "registerEmail",
  "verifyingEmail" = "verifyingEmail",
  "twoFactorAuth" = "twoFactorAuth",
}

export enum USER_EMAIL_TYPES {
  "NewAccountLink" = "NewAccountLink",
  "AccountCreated" = "AccountCreated",
  "VerifyEmailLink" = "VerifyEmailLink",
  "AccountChanged" = "AccountChanged",
  "AccountPasswordChanged" = "AccountPasswordChanged",
  "PasswordResetLink" = "PasswordResetLink",
  "PasswordReset" = "PasswordReset",
  "TwoFactorAuth" = "TwoFactorAuth",
  "InviteLink" = "InviteLink",
  "AccountApproved" = "AccountApproved",
}

export const VALID_USER_AUTH_STATES = Object.keys(USER_AUTH_STATES);
export const VALID_USER_ROLES: USER_ROLES[] = Object.keys(USER_ROLES) as USER_ROLES[];
export const VALID_ADMIN_ROLES: USER_ROLES[] = [USER_ROLES.Admin];
export const VALID_OPERATOR_ROLES: USER_ROLES[] = [USER_ROLES.Admin, USER_ROLES.Operator];
